import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import JobComponent from "../../components/job/JobComponent";
import Loading from "../../../components/isLoading";
import { fetchJobData } from "../../../redux/jobs";
import { Edit, Publish } from "@material-ui/icons";
import { toast } from "react-toastify";
import actionCreator from "../../../redux/action/actionCreator";
import { DeleteForever } from "@mui/icons-material";
import DeleteModel from "../DeleteModel";
import ConfirmModel from "../ConfirmModel";
import { DELETE_JOB } from "../../../redux/jobs/types";

const NewsletterContainer = (props) => {
  const { id } = props;
  const [state, setState] = useState({
    openDeleteMessage: false,
    openConfirmation: false,
  });
  const navigate = useNavigate();

  const jobData = useSelector((state) => state.jobGlobalStore);
  const deleteStore = useSelector((store) => store.deleteJobGlobalStore);
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(fetchJobData(id));
    }
  }, []);

  const handleOnEdit = () => navigate("edit");

  const handleOpenCloseConfirmModel = (condition) =>
    setState((prevState) => ({ ...prevState, openConfirmation: condition }));

  const handleOpenCloseDeleteModel = (condition) =>
    setState((prevState) => ({ ...prevState, openDeleteMessage: condition }));

  const isUnpublish = jobData.data?.status === "published";

  const crumps = [
    {
      title: "Jobs",
      path: "/jobs",
    },
  ];
  const actions = [
    {
      onClick: handleOnEdit,
      text: "Edit Job",
      icon: <Edit fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseConfirmModel(true),
      text: isUnpublish ? "Unpublish Job" : "Publish Job",
      icon: <Publish fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseDeleteModel(true),
      text: "Delete Job",
      icon: <DeleteForever fontSize="small" />,
    },
  ];
  return jobData.loading ? (
    <Loading />
  ) : (
    <div>
      <DeleteModel
        isOpen={state.openDeleteMessage}
        isFor="Jobs"
        handleCloseModel={() => handleOpenCloseDeleteModel(false)}
        itemId={id}
        store={deleteStore}
        action={DELETE_JOB}
      />
      <ConfirmModel
        isOpen={state.openConfirmation}
        isFor="Jobs"
        handleCloseModel={handleOpenCloseConfirmModel}
        itemId={id}
        isUnpublish={isUnpublish}
      />
      <JobComponent
        jobDetails={jobData.data || {}}
        crumps={crumps}
        actions={actions}
      />
    </div>
  );
};

export default NewsletterContainer;
